export default class extends Controller {
  connect() {
    App.Helpers.listenToCustomEvent(document, "timer-started", (() => this.isRunning = true));
    App.Helpers.listenToCustomEvent(document, "timer-stopped", (() => this.isRunning = false));
  }

  set isRunning(running) {
    this.element.classList[running ? "add" : "remove"]("is-running");
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/running-timer-button-controller.js